export const QUESTION_CONFIG_KEY = {
  REQUIRED: 'REQUIRED',
  REQUIRED_ERROR_MESSAGE: 'REQUIRED_ERROR_MESSAGE',
  NOT_APPLICABLE_OPTIONS: 'NOT_APPLICABLE_OPTIONS',
  ENABLE_NON_APPLICABLE: 'ENABLE_NON_APPLICABLE',
  BUTTON_TYPE: 'BUTTON_TYPE',
  SCALE_TYPE: 'SCALE_TYPE',
  VIEW_VARIANT: 'VIEW_VARIANT',
  NPS_BUTTON_VARIANT: 'NPS_BUTTON_VARIANT',
  SHOW_SCALE_NUMBERS: 'SHOW_SCALE_NUMBERS',
  TRANSPOSE_TABLE: 'TRANSPOSE_TABLE',
  REPEAT_SCALE: 'REPEAT_SCALE',
  ENABLE_SCALE: 'ENABLE_SCALE',
  MATRIX_TYPE: 'MATRIX_TYPE',
} as const;
